import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BugReportService } from './bug-report.service';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


export interface ApiResponse {
  code: number;
  data: unknown;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  base_url: string = "/api/"

  private http = inject(HttpClient);
  private bugReportService = inject(BugReportService);

  constructor() {
    if (window.location.hostname === 'localhost') {
      this.base_url = "https://beta.jar.games/api/"
    }
  }

  get(path: string): Observable<any> {
    console.log('[API] GET', this.base_url + path);
    return this.http.get(this.base_url + path, { withCredentials: true }).pipe(
      catchError((error: any) => {
        console.error('API Error:', error);
        this.bugReportService.addError({
          message: `API Error: ${error.message}`,
          timestamp: Date.now(),
          type: 'network',
          details: {
            url: this.base_url + path,
            status: error.status,
            statusText: error.statusText,
            error: error.error
          }
        });
        throw error;
      })
    );
  }

  post(path: string, data: any): Observable<any> {
    console.log('[API] POST', this.base_url + path);
    return this.http.post(this.base_url + path, data, { withCredentials: true }).pipe(
      catchError((error: any) => {
        console.error('API Error:', error);
        this.bugReportService.addError({
          message: `API Error: ${error.message}`,
          timestamp: Date.now(),
          type: 'network',
          details: {
            url: this.base_url + path,
            status: error.status,
            statusText: error.statusText,
            error: error.error,
            requestData: data
          }
        });
        throw error;
      })
    );
  }



}
